import { render, staticRenderFns } from "./FormCasdastroComponent.vue?vue&type=template&id=1a254d0b&scoped=true&"
import script from "./FormCasdastroComponent.vue?vue&type=script&lang=js&"
export * from "./FormCasdastroComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormCasdastroComponent.vue?vue&type=style&index=0&id=1a254d0b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a254d0b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs,VTabsItems})
